import { render } from "./ShareCode.vue?vue&type=template&id=ed3ddd44&scoped=true"
import script from "./ShareCode.vue?vue&type=script&lang=js"
export * from "./ShareCode.vue?vue&type=script&lang=js"

import "./ShareCode.vue?vue&type=style&index=0&id=ed3ddd44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ed3ddd44"

export default script